export default {
  promotional_text: 'Bespaar tijd & verdien beloningen!',
  description:
    'De {{name}} App is er – voor nog eenvoudiger bestellen:\n\n• Supersnel bestellen via app\n\n• Directe meldingen over acties en beloningen\n\n• Spaar en wissel uw punten eenvoudig in\n\n• Volg de status van uw bestelling in realtime\n\nWij bieden u graag onze app aan – en hopen dat u er net zoveel plezier aan beleeft als wij!`',
  keywords: 'Mobiele bestelling, Restaurant-app, Eten-app, Afhalen, Eten bestellen, Afhaalmaaltijden, Bezorgservice',
};
